/**
 * Centralized location validation utility.
 * Calls the same server-side ValidateAndSaveLocation endpoint used by LocationPickerField.
 * Returns a validation result object synchronously (uses synchronous XHR for use in "Done" button validators).
 *
 * Usage:
 *   import { validateLocation } from '@Utilities/LocationValidator';
 *   var result = validateLocation(locationData, translations);
 *   if (result.hasError) { ... }
 */

/**
 * Validates location data against the server.
 * @param {object} locationData - { Address, City, State, PostalCode, Country }
 * @param {object} translations - translations object (needs "IsRequired", "Location", keys)
 * @returns {{ hasError: boolean, errorText: string, errorKey: string }}
 */
export function validateLocation(locationData, translations) {
    var result = { hasError: false, errorText: '', errorKey: '' };

    if (!locationData) {
        result.hasError = true;
        result.errorKey = "locationRequired";
        result.errorText = translations["IsRequired"].replace("{0}", translations["Location"]);
        return result;
    }

    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/listinginput/Location/ValidateAndSaveLocation', false);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.send(JSON.stringify({
        Address: locationData.Address || '',
        City: locationData.City || '',
        State: locationData.State || '',
        PostalCode: locationData.PostalCode || '',
        Country: locationData.Country || '',
        DisplayText: locationData.DisplayText || '',
        CountryShortName: locationData.CountryShortName || '',
        StateShortName: locationData.StateShortName || ''
    }));

    if (xhr.status === 200) {
        var response = JSON.parse(xhr.response);
        if (response.error === "locationRequired") {
            result.hasError = true;
            result.errorKey = "locationRequired";
            result.errorText = translations["IsRequired"].replace("{0}", translations["Location"]);
        } else if (response.error) {
            result.hasError = true;
            result.errorKey = "locationInvalid";
            result.errorText = response.error;
        }
    }
    return result;
}
